import React, { useEffect } from 'react';
import Header from '../../components/common/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faTags } from '@fortawesome/free-solid-svg-icons';
import EtiquetasMasc from '../../components/CentralInformacoesEtiquetas';
import './stylesCentralDeInformacoesEtiquetas.css';

const CentralDeInformacoesEtiquetas = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const voltarInicio = () => {
    window.location.href = 'https://www.informezz.com.br/#/home';
  };

  return (
    <>
      <Header />

      <div className="ce-page">

        {/* Hero Banner */}
        <div className="ce-hero">
          <div className="ce-hero__content">
            <div className="ce-hero__icon">
              <FontAwesomeIcon icon={faTags} />
            </div>
            <h1 className="ce-hero__title">Etiquetas Informezz • MASC</h1>
            <p className="ce-hero__subtitle">Modelos disponíveis</p>
          </div>
        </div>

        {/* Conteúdo */}
        <div className="ce-wrapper">

          {/* Botão voltar */}
          <button className="ce-back-btn" onClick={voltarInicio}>
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>Voltar à Página Inicial</span>
          </button>

          <EtiquetasMasc />

        </div>
      </div>
    </>
  );
};

export default CentralDeInformacoesEtiquetas;
